import { useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { PageTable, Header } from "/src/layouts/page";
import Table from "/src/components/table";
import "/src/components/UI/Button/IconButton/IconButton.css";
import chatService from "../../services/ChatService";
import urlWithRoutingCompany from "/src/utils/urlWithRoutingCompany";
import { formatDate } from "/src/utils/formatDate";
import storage from "/src/utils/storage";
import Field from "/src/components/UI/Field/Field";
import "../../css/WarningRagApiKey.css";

function ThreadTable() {
    const navigate = useNavigate();
    const company = storage("session").get("company");
    const [apiError, setApiError] = useState(null);
    const [refreshKey, setRefreshKey] = useState(0);

    const fetchChats = useCallback(async () => {
        try {
            const [response, error] = await chatService.getChats();

            if (error) {
                if (error.status === 401) {
                    setApiError("Invalid API key. Please contact the Talkr administrator.");
                } else {
                    setApiError(`Error fetching data: ${error.message}`);
                }
                return [null, error];
            }

            const adaptedChats = response.chats.map((chat) => ({
                chat_id: chat.chat_id,
                chat_name: chat.chat_name || "Unnamed Chat",
                creation_time: chat.creation_time,
            }));

            setApiError(null);
            return [adaptedChats, null];
        } catch (error) {
            setApiError("An unexpected error occurred while fetching data.");
            return [[], error];
        }
    }, []);

    const cells = [
        {
            column: "NAME",
            name: "chat_name",
            sort: true,
            show: (value) => value,
        },
        {
            column: "CREATION",
            name: "creation_time",
            sort: true,
            show: (value) => formatDate(value),
        },
    ];

    const onClickDelete = async ({ row }) => {
        const { chat_id } = row;

        try {
            await chatService.deleteChat(chat_id);
            setRefreshKey((prev) => prev + 1);
        } catch (error) {
            console.error("Failed to delete chat:", error);
        }
    };

    const openChat = async ({ row }) => {
        const { chat_id } = row;

        navigate(urlWithRoutingCompany(`/ai/llm-rag/chat/${chat_id}`));
    };

    const actions = [
        { className: "fas fa-robot action-button edit_action", style: {}, onClick: openChat },
        { className: "fas fa-trash action-button delete_action", style: {}, onClick: onClickDelete },
    ].filter((action) => action);

    const filters = [{ type: "input", placeholder: "Search by name", name: "chat_name" }];

    if (!company?.api_key_rag || apiError) {
        return (
            <PageTable>
                <Header title="Chat History" />
                <div className="warning_container">
                    <Field listClassName="warning">
                        {apiError ||
                            "API key for Talkr RAG usage is not configured. Please contact the Talkr administrator."}
                    </Field>
                </div>
            </PageTable>
        );
    }

    return (
        <PageTable>
            <Header title={`Chat History`}></Header>
            <Table
                name="Chat"
                actions={actions}
                cells={cells}
                api={fetchChats}
                withPagination={false}
                filters={filters}
                defaultSort={{ column: "creation_time", val: false }}
                refreshState={[refreshKey]}></Table>
        </PageTable>
    );
}

export default ThreadTable;
